import React from 'react';
import ScrollAnimation from '../ScrollAnimation';
import FeatureGrid from '../features/FeatureGrid';

export default function IrreplacableFeatures() {
  return (
    <ScrollAnimation threshold={0} rootMargin="0px">
      <section id="features" className="py-20 bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 stagger-item">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white sm:text-4xl">
              The Benefits Of Our Method Will Propel You Forward
            </h2>
            <p className="mt-4 text-lg md:text-xl text-gray-300">
              Click each card to discover the transformative feature behind each outcome
            </p>
          </div>
          <FeatureGrid />
        </div>
      </section>
    </ScrollAnimation>
  );
}